// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__3wg09","actionsCol":"EnrolledClinics_actionsCol__2q4v9"};